import siteOptions from '@/config/index'

export function enableTracker(){
	let tickerSDK = 'https://img-oss.yunshanmeicai.com/weixin/mall/cdn/ticker/ticker.min.2.0.6.js'
  let script = document.createElement("script");
  script.type = "text/javascript";
  script.src = tickerSDK;
  script.onload = function(){
    mxticker.init(siteOptions['trackerOptions'])
  }
  document.head.appendChild(script);
}
